import { createFileRoute } from "@tanstack/react-router";
import HantavirusLiveMap from "@/components/HantavirusLiveMap";
import NewsSection from "@/components/NewsSection";
import FeedbackForm from "@/components/FeedbackForm";
import HVIFooter from "@/components/HVIFooter";
import SeoContent from "@/components/SeoContent";
import DailyTrendCharts from "@/components/DailyTrendCharts";
import OutbreakComparison from "@/components/OutbreakComparison";
import TravelRiskTool from "@/components/TravelRiskTool";
import SocialShare from "@/components/SocialShare";
import { buildSeo, SITE_URL, PUBLISHER } from "@/lib/seo";
import { useT } from "@/lib/i18n";
import { useDomTranslate } from "@/hooks/useDomTranslate";

export const Route = createFileRoute("/")({
  component: Index,
  head: () =>
    buildSeo({
      path: "/",
      title: "Hantavirus Live Outbreak Map — Global Real-Time Tracker",
      description:
        "Track the global hantavirus outbreak in real time. Live world map of confirmed, suspected and fatal cases with WHO, CDC, UKHSA and NCID-sourced country reports.",
      image: "/og/home.jpg",
      keywords: [
        "hantavirus map",
        "hantavirus tracker",
        "hantavirus outbreak 2026",
        "hantavirus live map",
        "andes virus",
        "ANDV",
        "HPS",
        "HFRS",
        "MV Hondius",
      ],
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          url: SITE_URL,
          name: "Hantavirus International",
          inLanguage: ["en", "tr"],
          publisher: PUBLISHER,
          potentialAction: {
            "@type": "SearchAction",
            target: `${SITE_URL}/?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "MedicalWebPage",
          name: "Hantavirus Live Outbreak Map",
          url: SITE_URL,
          about: {
            "@type": "MedicalCondition",
            name: "Hantavirus infection",
            alternateName: ["HPS", "HCPS", "HFRS"],
            code: { "@type": "MedicalCode", codingSystem: "ICD-10", code: "B33.4" },
          },
          audience: {
            "@type": "Audience",
            audienceType: "Public health, clinicians, travellers",
          },
          publisher: PUBLISHER,
        },
      ],
    }),
});

function Index() {
  const { lang } = useT();
  useDomTranslate("#home-content", lang, lang);
  return (
    <div id="home-content">
      <HantavirusLiveMap />
      <DailyTrendCharts />
      <OutbreakComparison />
      <TravelRiskTool />
      <SocialShare />
      <SeoContent />
      <NewsSection />
      <FeedbackForm />
      <HVIFooter />
    </div>
  );
}
